var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamonds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "black",
    stroke: "#8473FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4481 9.38512L13.7404 6.24133C13.7009 6.16865 13.641 6.10768 13.5673 6.0651C13.4935 6.02253 13.4088 6 13.3224 6H6.69713C6.61114 6 6.5268 6.02232 6.4533 6.06452C6.37979 6.10673 6.31994 6.1672 6.28027 6.23936L4.55302 9.38039C4.50775 9.46271 4.49085 9.55637 4.50471 9.64824C4.51857 9.7401 4.56248 9.82556 4.63028 9.89263L9.65507 14.8627C9.6989 14.9061 9.75156 14.9406 9.80987 14.9642C9.86818 14.9878 9.93093 15 9.99435 15C10.0577 15 10.1208 14.9879 10.179 14.9644C10.2373 14.9408 10.29 14.9064 10.3338 14.8631L15.3693 9.8958C15.437 9.82903 15.481 9.74393 15.4951 9.65238C15.5092 9.56084 15.4928 9.46741 15.4481 9.38512ZM12.7758 9.88543L10.3366 12.2917C10.2927 12.3349 10.2401 12.3694 10.1818 12.3929C10.1235 12.4164 10.0608 12.4285 9.99741 12.4285C9.93399 12.4285 9.87092 12.4163 9.81261 12.3927C9.7543 12.3691 9.70164 12.3346 9.65781 12.2913L7.22376 9.88368C7.0444 9.70628 7.05106 9.42495 7.23862 9.25531C7.42617 9.08565 7.72361 9.09196 7.90297 9.26936L9.99788 11.3415L12.0975 9.27026C12.2771 9.09309 12.5746 9.08718 12.7619 9.25705C12.9492 9.42692 12.9554 9.70826 12.7758 9.88543Z",
    fill: "url(#paint0_linear_17369_47380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17369_47380",
    x1: 12.006,
    y1: 6,
    x2: 9.50814,
    y2: 15.5854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB052"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamonds);
export default __webpack_public_path__ + "static/media/Diamonds.svg";
export { ForwardRef as ReactComponent };